const getFeatureToggle = (featureName) => {
  const globals = typeof window !== 'undefined' && window.__globals__ || {}

  if (!globals.features) {

    if (!process.env.UNIT_TESTS) {
      console.error(`Feature are not defined! FT name - ${featureName}`)
    }

    return false
  }

  if (!featureName) {
    return false
  }

  return globals.features[featureName]
}


export default getFeatureToggle
